import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { useTranslation } from "react-i18next";

interface Props {
  showRisks: boolean;
  withAgent?: string;
  riskList?: string[];
}

function CriminalConvictionAndDisability({ showRisks, withAgent, riskList = [] }: Props) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      {withAgent && (
        <SummaryRow
          key="workingWithAgent"
          label={t('forms.visa:withAgent')}
          fullLabel="Did anyone help you submit your application to study with us?"
          value={
            withAgent === 'No'
              ? 'No, I did it myself'
              : withAgent === 'School'
                ? 'Yes, a school counsellor'
                : withAgent === 'Agent'
                  ? 'Yes, an agent'
                  : 'Yes, someone else'
          }
          isRisk={showRisks && riskList.includes(Q.AGENT)}
        />
      )}
    </>
  );
}

export default CriminalConvictionAndDisability;
